import api from '../utils/api';

/**
 * Situations are the PUBLISHED read model. Everything here is a read: the editor
 * writes the draft canvas through CanvasServices.sendOps, and publish is what turns
 * that draft into these documents.
 */

const BASE = '/api/situations';

/**
 * Get all situations for a scenario (choices and situationGroup populated).
 * @route GET /api/situations/{scenarioId}/all
 * @param {string} scenarioId
 * @returns {Promise<Object[]>} Situations with choices and situationGroup populated
 */
export const getSituationsByScenario = (scenarioId) =>
    api.get(`${BASE}/${scenarioId}/all`).then((r) => r.data);

/**
 * Get the _id of the starting situation for a scenario.
 * @route GET /api/situations/starting/{scenarioId}
 * @param {string} scenarioId
 * @returns {Promise<{ _id: string }>}
 */
export const getStartingSituation = (scenarioId) =>
    api.get(`${BASE}/starting/${scenarioId}`).then((r) => r.data);

/**
 * Get a situation by id (choices and situationGroup populated).
 * @route GET /api/situations/situation/{situationId}
 * @param {string} situationId
 * @returns {Promise<Object>} Situation with choices and situationGroup populated
 */
export const getSituation = (situationId) =>
    api.get(`${BASE}/situation/${situationId}`).then((r) => r.data);

/**
 * Get a projected situation for viewer playback (minimal choice and group fields).
 * @route GET /api/situations/preview/{situationId}
 * @param {string} situationId
 * @returns {Promise<Object>} Projected situation for the viewer
 */
export const getSituationPreview = (situationId) =>
    api.get(`${BASE}/preview/${situationId}`).then((r) => r.data);
